export var PromoEvent;
(function (PromoEvent) {
    PromoEvent["PromoClick"] = "promoClick";
    PromoEvent["PromoView"] = "promoView";
    PromoEvent["PromoClose"] = "promoClose";
})(PromoEvent || (PromoEvent = {}));
export var EventAction;
(function (EventAction) {
    EventAction["Click"] = "click";
    EventAction["Close"] = "close";
    EventAction["View"] = "view";
    EventAction["Success"] = "success";
    EventAction["Login"] = "login";
    EventAction["Signup"] = "signup";
    EventAction["Error"] = "error";
})(EventAction || (EventAction = {}));
export var EventCategory;
(function (EventCategory) {
    EventCategory["Product"] = "product";
    EventCategory["User"] = "user";
    EventCategory["Link"] = "link";
})(EventCategory || (EventCategory = {}));
export var CartEvent;
(function (CartEvent) {
    CartEvent["AddToCart"] = "addToCart";
    CartEvent["RemoveFromCart"] = "removeFromCart";
})(CartEvent || (CartEvent = {}));
export var NewsletterSignupEvent;
(function (NewsletterSignupEvent) {
    NewsletterSignupEvent["NewsLetterSignUpClick"] = "newsLetterSignUpClick";
    NewsletterSignupEvent["NewsLetterSignUpSuccess"] = "newsLetterSignUpSuccess";
})(NewsletterSignupEvent || (NewsletterSignupEvent = {}));
export var NewsletterSignupName;
(function (NewsletterSignupName) {
    NewsletterSignupName["NewsletterOverlay"] = "NewsletterOverlay";
    NewsletterSignupName["NewsletterSignUp"] = "NewsletterSignUp";
})(NewsletterSignupName || (NewsletterSignupName = {}));
export var SignupEvent;
(function (SignupEvent) {
    SignupEvent["Login"] = "loginEvent";
    SignupEvent["LoginFailed"] = "loginFailed";
    SignupEvent["Register"] = "signUpEvent";
    SignupEvent["RegisterFailed"] = "signUpFailed";
})(SignupEvent || (SignupEvent = {}));
export var ErrorEvent;
(function (ErrorEvent) {
    ErrorEvent["ErrorView"] = "errorView";
})(ErrorEvent || (ErrorEvent = {}));
export var ErrorEventMessage;
(function (ErrorEventMessage) {
    ErrorEventMessage["NotSellable"] = "not sellable";
    ErrorEventMessage["GenericMessage"] = "generic message";
})(ErrorEventMessage || (ErrorEventMessage = {}));
